import { getDiscountPercent, getDiscountPrice } from '../discountUtils';
import { CartItem } from '../model';
import type { DiscountThreshold } from '../discountConfig';

const getTotalPriceWithShipping = (subtotal: number, shippingCost = 0) => {
  const total = shippingCost !== undefined ? subtotal + shippingCost : subtotal;

  return total;
};

const getItemPriceWithDiscount = (item: CartItem) => {
  const discountPercent = getDiscountPercent(item.slug, item.quantity, item.quantityDiscounts);
  const discountPrice = getDiscountPrice(item.slug, item.quantity, item.quantityDiscounts);

  const discountedPrice =
    discountPrice > 0 ? discountPrice : item.price * (1 - discountPercent / 100) * item.quantity;

  return {
    price: item.price * item.quantity,
    discountedPrice,
    discountDescription: '',
    discountPercent,
    appliedRule: undefined,
    appliedThreshold: undefined as DiscountThreshold | undefined,
    discountPrice,
  };
};

export { getTotalPriceWithShipping, getItemPriceWithDiscount };
